import React, {useState} from "react";
import USER from "../../../assets/images/user1.jpg";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import {
  Button,
  Modal,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  ModalHeader, ModalBody
} from "reactstrap";
import ActivityLogo from "../../../assets/images/activity.png";
import axiosInstance from "../../../helpers/axios";
import Activity from "../../Activity/Activity";
import { useSelector } from 'react-redux';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function ProfileCard(props) {
  const {
    applicationDetails,
    selfiePath,
    bankSelfieData,
    handleOpenDialog,
    isDialogOpen,
    handleCloseDialog,
    location,
    handleUser,
    handleCoApp
    ,status
  } = props;
  const decode = useCurrentUser();
  const { appId } = useSelector((state) => state.appContext);
  const user = null;
  const [modal, setModal] = useState(false);
  const [agreementUrl, setAgreementUrl] = useState(null);
  const [sanctionModal, setModalSanction] = useState(false);
  const [documentToggle, setDocumentToggle] = React.useState(false);
  const [sanctionUrl, setSanctionUrl] = useState(null);
  const toggle1 = () => {
    const url = `/file/url-content?path=${bankSelfieData?.agreementUrl}`;
    axiosInstance
      .get(url, {
        headers: {
        },
      })
      .then((res) => {
        setAgreementUrl(res?.data?.data);
      });
    setModal(!modal);
  };

  const toggleSanction = () => {
    const url = `/file/url-content?path=${bankSelfieData?.sanctionLetter}`;
    axiosInstance
      .get(url, {
        headers: {
        },
      })
      .then((res) => {
        setSanctionUrl(res?.data?.data);
      });
    setModalSanction(!sanctionModal);
  };

  const handleDocToggle = () => {
    setDocumentToggle(!documentToggle);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: "20px",
        }}
      >
        <img
          style={{ width: "7em", height: "7em", borderRadius: "50%" }}
          src={selfiePath ?? USER}
          alt="User"
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "20px",
          }}
        >
          <span
            style={{
              fontFamily: "Inter-Medium",
              fontWeight: "600",
              fontSize: "1.5vw",
              color: "#101828",
            }}
          >
            {appId}
          </span>
          {location?.state?.coapplicants?.length > 1 ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1em",
                flexWrap: "wrap",
              }}
            >
              <span
                className="coappName"
                onClick={() => handleUser(applicationDetails)}
              >{`${location?.state?.name}`}</span>

              {location?.state?.coapplicants?.map((coapp, index) => {
                return (
                  <span
                    className="coappName"
                    key={index}
                    onClick={() => handleCoApp(coapp)}
                  >{`${coapp?.coapplicantName} - C${index + 1}`}</span>
                );
              })}
            </span>
          ) : (
            <p>
              <span
                style={{
                  fontFamily: "Inter-Medium",
                  fontWeight: "500",
                  fontSize: "1vw",
                  color: "#667085",
                }}
              >
                {" "}
                Applicant:
              </span>
              <span
                style={{
                  fontFamily: "Inter-Medium",
                  fontWeight: "500",
                  fontSize: "1vw",
                  color: "#D32028",
                  marginLeft: "7px",
                  cursor: "pointer",
                }}
                onClick={() => handleUser(applicationDetails)}
              >
                {applicationDetails?.profile?.userDetails?.name
                  ?.toLowerCase()
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ") || "-------"}
              </span>
              {applicationDetails?.coapplicantProfile?.userDetails?.name && (
                <>
                  <span style={{ marginLeft: "10px", marginRight: "10px" }}>
                    |
                  </span>
                  <span
                    style={{
                      fontFamily: "Inter-Medium",
                      fontWeight: "500",
                      fontSize: "1vw",
                      color: "#667085",
                    }}
                  >
                    Co-applicant:
                  </span>
                  <span
                    style={{
                      fontFamily: "Inter-Medium",
                      fontWeight: "500",
                      fontSize: "1vw",
                      color: "#D32028",
                      marginLeft: "7px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleCoApp()}
                  >
                    {applicationDetails.coapplicantProfile.userDetails.name
                      ?.toLowerCase()
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}
                  </span>
                </>
              )}
            </p>
          )}
          {/* <span style={{fontFamily:'Inter-Medium',fontWeight:'500',fontSize:'18px',color:'#667085'}}>Applicant <span style={{fontFamily:'Inter-Medium',fontWeight:'500',fontSize:'18px',color:'#D32028',marginLeft:'7px'}}> {applicationDetails ? applicationDetails?.profile.userDetails.name : null}</span></span> */}
          <span
            style={{
              fontFamily: "Inter-Medium",
              fontWeight: "500",
              fontSize: "16px",
              color: "#667085",
            }}
          >
            {" "}
            Work{" "}
            <span
              style={{
                fontFamily: "Inter-Medium",
                fontWeight: "500",
                fontSize: "16px",
                color: "#D32028",
                marginLeft: "7px",
              }}
            >
              {applicationDetails
                ? applicationDetails?.profile?.userDetails?.company
                : null}{" "}
            </span>
            {status !== "In Submission" || status !== "In Review" ? (
              <span
                style={{
                  fontFamily: "Inter-Medium",
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "#667085",
                  marginLeft: "8em",
                }}
              >
                {" "}
                Product
                <span
                  style={{
                    fontFamily: "Inter-Medium",
                    fontWeight: "500",
                    fontSize: "16px",
                    color: "#D32028",
                    marginLeft: "7px",
                  }}
                >
                  {applicationDetails?.profile?.productData?.name}{" "}
                </span>
              </span>
            ) : null}
          </span>
        </div>
      </div>
      <Modal isOpen={modal} size="xl" style={{ height: "100%" }}>
        <ModalHeader toggle={toggle1}>Agreement</ModalHeader>
        <ModalBody>
          <iframe
            title="Agreement"
            src={agreementUrl}
            width="100%"
            height="1000vh"
            style={{ border: "none" }}
          ></iframe>
        </ModalBody>
      </Modal>
      <Modal isOpen={sanctionModal} size="xl" style={{ height: "100%" }}>
        <ModalHeader toggle={toggleSanction}>Sanction Letter</ModalHeader>
        <ModalBody>
          <iframe
            title="Agreement"
            src={sanctionUrl}
            width="100%"
            height="1000vh"
            style={{ border: "none" }}
          ></iframe>
        </ModalBody>
      </Modal>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={handleOpenDialog}
          style={{
            color: "white",
            cursor: "pointer",
            fontFamily: "Inter-Medium",
            fontSize: "1rem", // Adjusted for better scaling
            width: "100%", // Makes it flexible
            maxWidth: "150px", // Prevents excessive growth
            height: "45px", // Scales better across screens
            backgroundColor: "#d32028",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderColor: "#d32028",
            padding: "10px",
            marginBottom: "5px",
            marginRight: "20px",
          }}
        >
          <img
            style={{ marginRight: "5px", width: "20px", height: "20px" }} // Scaled properly
            src={ActivityLogo}
            alt="activity"
          />
          Activity
        </Button>

        <Dialog
          fullScreen
          open={isDialogOpen}
          onClose={handleCloseDialog}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
              width: "50%",
              maxWidth: "80vw",
              height: "100vh",
              ml: "auto",
              borderTopLeftRadius: "15px",
              borderBottomLeftRadius: "15px",
            },
          }}
        >
          <DialogContent>
            <Activity />
          </DialogContent>
        </Dialog>

        <Dropdown
          style={{ marginBottom: "1em" }}
          isOpen={documentToggle}
          toggle={() => handleDocToggle()}
        >
          <DropdownToggle
            caret
            style={{
              backgroundColor: "#d32028",
              border: "none",
              height: "2.8em",
            }}
          >
            Documents
          </DropdownToggle>
          <DropdownMenu style={{}}>
            <DropdownItem
              disabled={bankSelfieData?.agreementUrl ? false : true}
            >
              <div onClick={toggle1}>Agreement</div>
            </DropdownItem>
            <DropdownItem
              disabled={bankSelfieData?.sanctionLetter ? false : true}
            >
              <div
                href={bankSelfieData?.sanctionLetter}
                target="_blank"
                rel="noreferrer"
                onClick={toggleSanction}
              >
                Sanction Letter
              </div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
}
